import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import CircleMinus from "@store/Components/Icons/CircleMinus";
import CirclePlus from "@store/Components/Icons/CirclePlus";
import { transitionHoverStyles } from "@store/theme/common/mixins";
import { productListFiltersTitleProps } from "@store/theme/common/props/productListFilters";
import { css } from "styled-components";

const _sectionHeaderButtonBaseStyles = () => {
    return css<AccordionSectionHeaderProps>`
        padding: 0.5em 0;
        border: 0;
    `;
};

const _sectionHeaderButtonFocusStyles = () => {
    return css`
        &:focus {
            ${_sectionHeaderButtonBaseStyles()}
            outline-color: ${getProp("theme.focus.color")};
            outline-style: ${getProp("theme.focus.style")};
            outline-width: ${getProp("theme.focus.width")};
            outline-offset: -${getProp("theme.focus.width")};
        }
    `;
};

export const accordionFilterSectionProps: AccordionSectionPresentationProps = {
    headerProps: {
        css: css`
            padding: 0.5em 0;
            background-color: transparent;
            border-top: 1px solid ${getColor("common.border")};
            border-bottom: 1px solid ${getColor("common.border")};
            ${({ expanded }) =>
                expanded
                    ? css`
                          border-bottom-color: transparent;
                      `
                    : null}

            button {
                background-color: transparent;
                font-size: inherit;
                ${_sectionHeaderButtonBaseStyles()}
                ${_sectionHeaderButtonFocusStyles()}

                ${IconWrapper} {
                    ${transitionHoverStyles("color")}
                }

                &:hover {
                    text-decoration: underline;
        
                    ${IconWrapper} {
                        color: ${getColor("secondary")};
                    }
                }
            }

            ${/* sc-selector */ AccordionSectionPanel} + && {
                margin-top: -1px;

                button {
                    ${_sectionHeaderButtonBaseStyles()}
                    ${_sectionHeaderButtonFocusStyles()}
                }
            }
        `,
    },
    panelProps: {
        css: css`
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 350px;
            padding: 0 0 1em;
            border: 0;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
    titleTypographyProps: {
        ...productListFiltersTitleProps,
        forwardAs: "span",
    },
    toggleIconProps: {
        css: css``,
    },
    collapseIconProps: {
        color: "primary",
        src: CircleMinus,
    },
    expandIconProps: {
        color: "primary",
        src: CirclePlus,
    },
    toggleTransition: {
        transitionCss: css`
            bottom: -2px;
            transition: none;
        `,
        timeout: { enter: 0, exit: 0 },
    },
};
